import React from "react"
import StatisticsCards from "../StatisticsCards"
import AffiliateBanner from "./AffiliateBanner"
import AffiliateSection1 from "./AffiliateSection1"
import AffiliateSection2 from "./AffiliateSection2"
import AffiliateSection3 from "./AffiliateSection3"
import AffiliateHero from "./AffiliateHero"

const Affiliates = () => {
  return (
    <div className="w-full">
      <AffiliateHero />
      <StatisticsCards />
      <AffiliateSection1 />
      <AffiliateBanner banner="AffiliatePageBanner1" />
      <AffiliateSection2 />
      <AffiliateSection3 />
      <AffiliateBanner banner="AffiliatePageBanner2" />
    </div>
  )
}

export default Affiliates
